import { ShowcaseTemplates } from 'components'
import Helmet from 'react-helmet'

import connectToStores from 'alt-utils/lib/connectToStores'
import { SEOSettingsActions } from 'actions'
import { SEOSettingsStore } from 'stores'
import Enum from 'utils/Enum'
import { APP_NAME } from 'consts'


export default class OnboardingShowcaseContainer extends React.Component {
  render() {
    return (
      <div>
        <div className="setup-logo-container">
          <img className="setup-brand-symbol" alt="Plug in Useful" src="../../assets/images/brand-symbol.png" />
          <img className="setup-logo" alt={APP_NAME} src="../../assets/images/logo-color.png" />
        </div>
        <Helmet title='Plug in SEO - Recommended Templates' />
        <div className="onboardingShowcase">
          <ShowcaseTemplates
            nextRouteA="/plus/manage?autoInstall=true"
            nextRouteB="/plus/manage"
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/OnboardingShowcaseContainer.js